module.exports = __webpack_public_path__ + "static/media/white_noun-993426-cc.dc73ebdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_noun-993426-cc.svg
// module id = 260
// module chunks = 0